/**
 * @desc 查看参数列表中的设备列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** baseCode */
  baseCode?: string;
  /** equipmentName */
  equipmentName?: string;
  /** factoryCode */
  factoryCode?: string;
  /** sectionCode */
  sectionCode?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamDeviceResponse>>> {
  return defHttp.get({
    url: '/wap/ParamManage/getDevice',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamDeviceResponse>>> {
  return defHttp.get({
    url: '/mock/wap/ParamManage/getDevice',

    params,
  });
}
